import React from "react";

const iconProps = { width: 16, height: 16, viewBox: "0 0 24 24", fill: "none", "aria-hidden": true };

export const IconUser = () => (
  <svg {...iconProps} className="gf-user-dashboard__ico">
    <path
      d="M12 12a4 4 0 100-8 4 4 0 000 8zM4 20a8 8 0 0116 0"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
    />
  </svg>
);

export const IconMail = () => (
  <svg {...iconProps} className="gf-user-dashboard__ico">
    <path
      d="M4 6h16v12H4V6z"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinejoin="round"
    />
    <path d="M4 7l8 6 8-6" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" />
  </svg>
);

export const IconBuilding = () => (
  <svg {...iconProps} className="gf-user-dashboard__ico">
    <path
      d="M4 20h16M6 20V8l6-3 6 3v12M9 20v-4h2v4M13 20v-4h2v4"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconMap = () => (
  <svg {...iconProps} className="gf-user-dashboard__ico">
    <path
      d="M12 21s7-4.5 7-11a7 7 0 10-14 0c0 6.5 7 11 7 11z"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinejoin="round"
    />
    <circle cx="12" cy="10" r="2" stroke="currentColor" strokeWidth="1.75" />
  </svg>
);

export const IconCalendar = () => (
  <svg {...iconProps} className="gf-user-dashboard__ico">
    <path
      d="M4 6h16v14H4V6zM4 10h16M8 4v4M16 4v4"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconGlobe = () => (
  <svg {...iconProps} className="gf-user-dashboard__ico">
    <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.75" />
    <path
      d="M3 12h18M12 3a15 15 0 000 18M12 3a15 15 0 010 18"
      stroke="currentColor"
      strokeWidth="1.75"
    />
  </svg>
);

export const IconPhone = () => (
  <svg {...iconProps} className="gf-user-dashboard__ico">
    <path
      d="M6 3h4l2 6-3 2a12 12 0 006 6l2-3 6 2v4a2 2 0 01-2 2C8.5 22 2 15.5 2 8a2 2 0 012-2z"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconGitHub = () => (
  <svg {...iconProps} width={18} height={18} className="gf-user-dashboard__ico gf-user-dashboard__ico--btn">
    <path
      fill="currentColor"
      d="M12 2C6.477 2 2 6.477 2 12c0 4.42 2.865 8.17 6.839 9.49.5.092.682-.217.682-.482 0-.237-.008-.866-.013-1.7-2.782.603-3.369-1.34-3.369-1.34-.454-1.156-1.11-1.464-1.11-1.464-.908-.62.069-.608.069-.608 1.003.07 1.531 1.03 1.531 1.03.892 1.529 2.341 1.087 2.91.831.092-.646.35-1.086.638-1.336-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0112 6.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.202 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.943.359.309.678.92.678 1.855 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.001 10.001 0 0022 12c0-5.523-4.477-10-10-10z"
    />
  </svg>
);

export const IconLink = () => (
  <svg {...iconProps} width={18} height={18} className="gf-user-dashboard__ico gf-user-dashboard__ico--btn">
    <path
      d="M10 13a5 5 0 010-7l1-1a5 5 0 017 7l-1 1M14 11a5 5 0 010 7l-1 1a5 5 0 01-7-7l1-1"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
    />
  </svg>
);
